<ion-modal (ionModalDidPresent)="onTest()"
           #modal
           [handle]="false"
           [initialBreakpoint]="option.initialBreakpoint"
           [breakpoints]="option.breakpoints">

  <ion-content class="white-background">
    <ng-template>

      <div *ngIf="imageHeader"
           [appBackgroundImage]="imageHeader"
           class="w-100 modal-image-header"
           [ngClass]="imageHeaderClass">
        <div class="close-btn"
             (click)="close()">
          <ion-icon class="ts-h4 text-neutral-600" name="close"></ion-icon>
        </div>
        <div class="overlay-img shadow-15"></div>
      </div>

      <div class="block px-sm pt-md"
           style="position: relative;">

        <div *ngIf="!imageHeader" class="d-flex ion-justify-content-end">
          <div class="ts-body-semibold text-neutral-500" (click)="close()">
            {{ 'chiudi' | translate }}
          </div>
          <ion-modal trigger="open-modal"
                     (ionModalDidPresent)="onTest()"
                     #modal
                     [handle]="false"
                     [initialBreakpoint]="option.initialBreakpoint"
                     [breakpoints]="option.breakpoints">

            <ion-content>
              <ng-template>

                <div *ngIf="imageHeader"
                     [appBackgroundImage]="imageHeader"
                     class="w-100 modal-image-header">
                  <div class="ts"
                       style="color: white;position: absolute;right: 16px;top:16px;z-index: 999"
                       (click)="close()">Chiudi
                  </div>
                  <div class="overlay-img"></div>
                </div>

                <div class="block px-sm pt-md"
                     style="position: relative;">

                  <div *ngIf="!imageHeader" class="d-flex ion-justify-content-end">
                    <div class="ts-body-semibold text-neutral-500" (click)="close()">
                      {{ 'chiudi' | translate }}
                    </div>
                  </div>

                  <div>
                    <ng-content select="[preTitle]"></ng-content>
                  </div>

                  <div class="d-flex ion-justify-content-between">
                    <div class="pr-xs">
                      <div class="ion-text-capitalize font-medium font-weight-black">{{ title }}</div>
                      <div class=" font-weight-black ">{{ subTitle }}</div>
                    </div>

                  </div>

                  <div class="py-md">
                    <ng-content select="[content]"></ng-content>
                  </div>

                </div>

              </ng-template>
            </ion-content>

            <ion-footer>
              <ion-toolbar>
                <ng-content select="[footer]"></ng-content>
              </ion-toolbar>
            </ion-footer>

          </ion-modal>
        </div>

        <div>
          <ng-content select="[preTitle]"></ng-content>
        </div>

        <div class="d-flex ion-justify-content-between">
          <div class="pr-xs">
            <div class="ion-text-capitalize font-medium font-weight-black">{{ title }}</div>
            <div class=" font-weight-black ">{{ subTitle }}</div>
          </div>

        </div>

        <div class="py-md">
          <ng-content select="[content]"></ng-content>
        </div>

      </div>

      <div class="py-sm w-100 drawer-footer px-sm safe-area-bottom" #footerTmp>
        <ng-content select="[footer]"></ng-content>
      </div>

    </ng-template>
  </ion-content>

</ion-modal>
